import { Clock } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';
import { useAccountActivity } from '@/hooks/use-account';

const formatWhen = (iso: string) => {
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
};

export function ActivityTimeline() {
  const { data, isLoading } = useAccountActivity();
  const events = data?.events ?? [];

  if (isLoading) {
    return (
      <div className='space-y-3'>
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className='h-12 w-full' />
        ))}
      </div>
    );
  }

  if (events.length === 0) {
    return (
      <p className='py-8 text-center text-sm text-muted-foreground'>
        No activity recorded yet.
      </p>
    );
  }

  return (
    <ol className='space-y-4'>
      {events.map((e) => (
        <li key={e.id} className='flex gap-3'>
          <div className='mt-0.5'>
            <Clock className='h-4 w-4 text-muted-foreground' />
          </div>
          <div className='min-w-0'>
            <p className='text-sm'>{e.summary}</p>
            <p className='text-xs text-muted-foreground'>{formatWhen(e.when)}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}
